/**
 * 업로드 흐름의 공용 타입·에러 클래스.
 *
 * `useAssetUpload.ts` 본체는 `@crabs-ai/ds-react` / `next-intl` 등 React
 * 런타임 의존성을 끌어오므로, store 단위 테스트에서 hook 본체 import 가
 * chain 폭발을 일으킨다. 본 파일은 React 의존성이 없어 안전하게 import 가능.
 */

export interface OnCompleteResult {
  id: number;
  preSignedUrl: string;
  thumbnailPreSignedUrl?: string;
  // FE 썸네일 업로드 성공 여부. false면 서버(AI media-process)가 폴백 생성하므로 리스트 갱신 지연 필요
  thumbnailUploaded?: boolean;
}

/**
 * 업로드 실패 시 contentId를 전달하기 위한 커스텀 에러
 * presigned URL 발급 후 S3 업로드/완료 처리 단계에서 실패 시 사용
 */
export class UploadError extends Error {
  contentId?: number;
  constructor(message: string, contentId?: number) {
    super(message);
    this.name = 'UploadError';
    this.contentId = contentId;
  }
}
